import { AppTooltip } from '@components'
import { LayoutGrid, List } from 'lucide-solid'
import { For, Show } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Box, Flex } from 'styled-system/jsx'
import { type CardColumns, type ViewMode, useList } from '../state'
import { segButton, segTrack } from './segStyles'

const columnOptions: CardColumns[] = [3, 4, 5]

const dimmed = css({
  opacity: 0.4,
  pointerEvents: 'none',
  transition: 'opacity 0.15s',
})

export const ViewSelector = () => {
  const { viewMode, setViewMode, cardColumns, setCardColumns, compactColumns } = useService(useList)()

  return (
    <Flex
      gap={2}
      alignItems="center"
    >
      <div
        role="group"
        aria-label="View"
        class={segTrack}
      >
        <AppTooltip
          delay={900}
          content='Card view'
        >
          <button
            type="button"
            aria-pressed={viewMode() === 'card'}
            class={segButton(viewMode() === 'card')}
            onClick={() => setViewMode('card')}
          >
            <LayoutGrid size={16} />
          </button>
        </AppTooltip>

        <AppTooltip
          delay={900}
          content='List view'
        >
          <button
            type="button"
            aria-pressed={viewMode() === 'list'}
            class={segButton(viewMode() === 'list')}
            onClick={() => setViewMode('list')}
          >
            <List size={16} />
          </button>
        </AppTooltip>
      </div>

      <Box display={{ base: 'contents', smDown: 'none' }}>
        <div
          role="group"
          aria-label="Cards across"
          aria-disabled={viewMode() !== 'card'}
          class={viewMode() === 'card' ? segTrack : `${segTrack} ${dimmed}`}
        >
          <For each={columnOptions}>
            {(cols) => {
              const tooWide = () => compactColumns() && cols > 3
              const button = (
                <button
                  type="button"
                  disabled={viewMode() !== 'card' || tooWide()}
                  aria-pressed={cardColumns() === cols}
                  class={segButton(cardColumns() === cols)}
                  onClick={() => setCardColumns(cols)}
                >
                  {cols}
                </button>
              )

              return (
                <Show when={tooWide()} fallback={button}>
                  <AppTooltip
                    delay={900}
                    content='Not enough room at this window size'
                  >
                    {button}
                  </AppTooltip>
                </Show>
              )
            }}
          </For>
        </div>
      </Box>
    </Flex>
  )
}
